import styled from 'styled-components';
export const Header = styled.div `
    width: 100%;
    flex: 1;
    opacity: ${({ isSeeking }) => (isSeeking ? 0.2 : 1)};
    background-image: ${({ gradient }) => `linear-gradient(to top, ${gradient === null || gradient === void 0 ? void 0 : gradient.colors[0]}, ${gradient === null || gradient === void 0 ? void 0 : gradient.colors[1]})`};
    @media (max-width: 800px) {
        height: 140px;
    }
`;
Header.displayName = 'Header';
export const HeaderContainer = styled.div `
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    margin: 20px 20px 0;
    margin-top: ${({ isFullscreen, isLandscape }) => isFullscreen && (!isLandscape ? '100px' : '30px')};
`;
Header.displayName = 'HeaderContainer';
//# sourceMappingURL=index.js.map